"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentInfoQueryCardTypeEnum = exports.PaymentInfoQueryToJSON = exports.PaymentInfoQueryFromJSONTyped = exports.PaymentInfoQueryFromJSON = void 0;
const runtime_1 = require("../runtime");
function PaymentInfoQueryFromJSON(json) {
    return PaymentInfoQueryFromJSONTyped(json, false);
}
exports.PaymentInfoQueryFromJSON = PaymentInfoQueryFromJSON;
function PaymentInfoQueryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'creditCardLastFour': !runtime_1.exists(json, 'creditCardLastFour') ? undefined : json['creditCardLastFour'],
        'cardType': !runtime_1.exists(json, 'cardType') ? undefined : json['cardType'],
    };
}
exports.PaymentInfoQueryFromJSONTyped = PaymentInfoQueryFromJSONTyped;
function PaymentInfoQueryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'creditCardLastFour': value.creditCardLastFour,
        'cardType': value.cardType,
    };
}
exports.PaymentInfoQueryToJSON = PaymentInfoQueryToJSON;
/**
* @export
* @enum {string}
*/
var PaymentInfoQueryCardTypeEnum;
(function (PaymentInfoQueryCardTypeEnum) {
    PaymentInfoQueryCardTypeEnum["Visa"] = "Visa";
    PaymentInfoQueryCardTypeEnum["MasterCard"] = "MasterCard";
    PaymentInfoQueryCardTypeEnum["AmericanExpress"] = "AmericanExpress";
    PaymentInfoQueryCardTypeEnum["Discover"] = "Discover";
    PaymentInfoQueryCardTypeEnum["UNKNOWN"] = "UNKNOWN";
    PaymentInfoQueryCardTypeEnum["INVALIDVALUE"] = "_INVALID_VALUE";
})(PaymentInfoQueryCardTypeEnum = exports.PaymentInfoQueryCardTypeEnum || (exports.PaymentInfoQueryCardTypeEnum = {}));
//# sourceMappingURL=PaymentInfoQuery.js.map